import { defineLegacyDefaultTheme } from './defineLegacyDefaultTheme';

/** A deep midnight blue with a periwinkle accent. */
export const moonTheme = defineLegacyDefaultTheme({
  id: 'Moon',
  tokens: {
    a0: { l: 0.7, c: 0.15, h: 255 },
    a1: { l: 0.7, c: 0.15, h: 295 },
    a2: { l: 0.7, c: 0.15, h: 335 },
    a3: { l: 0.7, c: 0.15, h: 15 },
    a4: { l: 0.7, c: 0.15, h: 55 },
    b0: { l: 0.15, c: 0.012, h: 255 },
    b1: { l: 0.19, c: 0.012, h: 255 },
    b2: { l: 0.23, c: 0.014, h: 255 },
    b3: { l: 0.26, c: 0.014, h: 255 },
    b4: { l: 0.3, c: 0.016, h: 255 },
    c0: { l: 0.95, c: 0.01, h: 255 },
    c1: { l: 0.85, c: 0.01, h: 255 },
    c2: { l: 0.75, c: 0.01, h: 255 },
    c3: { l: 0.65, c: 0.01, h: 255 },
    c4: { l: 0.57, c: 0.01, h: 255 },
  },
});
